<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0;border:0" >
                <FormTitle :titleText="$t('基本信息')"/><!-- 基本信息 -->
                <div slot="content" style="margin-top: 40px;">
                    <Form :label-width="160" label-position="left">
                        <Row :gutter="100" >
                            <Col :xs="24" :sm="24" :md="24" :lg="16">
                                <Row :gutter="100">
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Employee_Number')"><!-- 员工编码 -->
                                            <Input v-model="formItem.empcode" disabled />
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('EMP_English_Name')"><!-- 英文名 -->
                                            <Input v-model="formItem.e_first_name" disabled/>
                                        </FormItem>
                                    </Col>
                                    <!-- <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Last_Name')"> 英文姓 
                                            <Input v-model="formItem.e_sur_name" disabled/>
                                        </FormItem>
                                    </Col> -->
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Chinese_Name')"><!-- 中文姓名 -->
                                        <Input v-model="formItem.c_name" disabled/>
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Date_of_Birth')"><!-- 出生日期 -->
                                            <DatePicker :value="formItem.birthday" @on-change="birthdayChange" type="date" disabled ></DatePicker>
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Age')"><!-- 年龄 -->
                                            <Input v-model="formItem.empold" disabled/>
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Gender')"><!-- 性别 -->
                                            <Input v-model="formItem.gender" disabled/>
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id==''">
                                        <FormItem :label="$t('Marital_Status')"><!-- 婚姻状况 -->
                                            <Select v-model="formItem.marital" transfer clearable disabled>
                                                <Option v-for="item in MARITALList" :value="item.code" :key="item.code" >{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                            </Select>
                                            <!-- <Input v-model="formItem.marital" @on-change="itemChange('marital')"/> -->
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Location')"><!-- 区域 -->
                                            <Input v-model="formItem.district" disabled/>
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id==''">
                                        <FormItem :label="$t('Current_Address')"><!-- 常住地址 -->
                                            <Input v-model="formItem.raddress" @on-change="itemChange('raddress')" disabled/>
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id==''">
                                        <FormItem :label="$t('Registered_Address')"><!-- 户籍地址 -->
                                            <Input v-model="formItem.address1" @on-change="itemChange('address1')" disabled />
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Mobile')"><!-- 手机 -->
                                            <Input v-model="formItem.mobile" disabled @on-change="itemChange('mobile')" />
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id==''">
                                        <FormItem :label="$t('Personal_Email')"><!-- 个人电子邮件 -->
                                            <Input v-model="formItem.pager" @on-change="itemChange('pager')" disabled />
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Effective_Join_Date')"><!-- 有效雇佣日 -->
                                            <DatePicker v-model="formItem.hirevalid" type="date" disabled></DatePicker>
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12">
                                        <FormItem :label="$t('Probation_End_Date')"><!-- 试用期结束日 -->
                                            <DatePicker v-model="formItem.probationenddate" type="date" disabled></DatePicker>
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id==''">
                                        <FormItem :label="$t('Bank_Account')"><!-- 银行卡号 -->
                                            <Input v-model="formItem.bankid1" disabled  />
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id==''">
                                        <FormItem :label="$t('Bank_Name_')"><!-- 银行名称 -->
                                            <!-- <DatePicker type="date" v-model="formItem.meetingDate" style="width:100%"></DatePicker> -->
                                            <Input v-model="formItem.bankname1" disabled />
                                        </FormItem>
                                    </Col>
                                    <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id==''">
                                        <FormItem :label="$t('CNAPS')"><!-- 银行行号 -->
                                            <Input v-model="formItem.bankname2" disabled />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col>
                            <Col :xs="24" :sm="24" :md="24" :lg="4" style="height:220px">
                                <div class="headerimg">
                                    <img v-if="domCheck&&formItem.portrait" :src="'data:image/jpeg;base64,' + formItem.portrait || ''" alt="" />
                                    <img id="imageId" v-else src="@/assets/headerImg.png" />
                                    <p v-if="id==''" style="font-size:14px;color:red;margin-bottom:10px"><!-- 上传图片大小不超过 2M -->{{$t('longText36')}}</p>
                                    <Upload
                                    accept="image"
                                        :format="['jpg','jpeg','png']"
                                        :action="action"
                                        :show-upload-list="false"
                                        :before-upload="beforeUpLoad"
                                        :on-success="uploadPortraitSuccess"
                                        :max-size="2048"
                                        :on-exceeded-size="handleMaxSize"
                                        :on-error="handleUpload">
                                        <Button :disabled='id!=""'><!-- 图片上传 -->{{$t('Upload_Image')}}</Button>
                                    </Upload>
                                    
                                    <Spin size="large" fix v-if="imgSpin"></Spin>
                                </div>
                            </Col>
                        </Row>
                        
                    </Form>
                </div>
            </Panel>
            <div  v-if="id==''">
                <span style="color: red;">{{$t('EmpFilesBasicComment')}}</span>
            </div> 
        </Collapse>
        
        <Spin size="large" fix v-if="spinShow"></Spin>
        <Divider />
       
        <div class="btnfooter" v-if="id==''">
            <Button type="primary" class="btn" @click="save"> <!--保存 -->{{$t('Save')}}</Button>
        </div>
        
    </div>
</template>

<script>
import axios from 'axios'
import fileUtil from "@/util/fileUtil.js"
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            spinShow:false,
            formItem:{},
            date: new DateUtil(),
            list:[],
            value:[1],
            domCheck:true,
            // action: "/api/BasicInformation/uploadUserPortrait",
            id:'',
            serialnumber:'',
            changeItem:{},
            MARITALList:[],
            imgSpin:false
        }
    },
    computed: {
        action() {
            return "/api/BasicInformation/uploadUserPortrait"
        },
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    methods:{
        getData(val){
            this.spinShow=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/employeeInformation/getEmployeeInformation", {serialnumber:this.serialnumber}).then((res) => {
                this.spinShow=false
                if (res) {
                   this.MARITALList=res.MARITALList
                   this.formItem=res
                }
            })
        },
        uploadPortraitSuccess(response, file, fileList) {
            this.formItem.portrait = response.data.data;
            this.formItem.resourceId = response.data.resourceId;
            this.domClick();
            this.imgSpin=false
        },
        handleUpload(error) {
            this.imgSpin=false
            this.$Message.info(this.$t('图片上传失败'));
        },
        handleMaxSize (file) {
            this.imgSpin=false
               this.$Message.error(this.$t('longText36'));
        },
        beforeUpLoad(file) {
            this.imgSpin=true
                return new Promise((resolve) => {
                    fileUtil.getOrientation(file).then((orient) => {
                        if (orient && orient === 6) {
                            let reader = new FileReader()
                            let img = new Image()
                            reader.onload = (e) => {
                                img.src = e.target.result
                                img.onload = function () {
                                    const data = fileUtil.rotateImage(img, img.width, img.height)
                                    const newFile = fileUtil.dataURLtoFile(data, file.name)
                                    
                                    resolve(newFile)
                                }
                            }
                            reader.readAsDataURL(file)
                        } else {
                            resolve(file)
                        }
                    })
                })
            },
        rotateImage: (image, width, height) => {
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            ctx.save()
            canvas.width = height
            canvas.height = width
            ctx.rotate(90 * Math.PI / 180)
            ctx.drawImage(image, 0, -height)
            ctx.restore()
            return canvas.toDataURL("image/jpeg")
        },    
        domClick() {
            this.domCheck = false;
            this.$nextTick(() => {
                this.domCheck = true;
            });
        },
        itemChange(key){
            // this.changeItem[key]=this.formItem[key]
        },
        save(){
            this.formItem.brithday=this.date.dateVal(this.formItem.brithday,'YYYY-MM-DD')
            this.$Modal.confirm({
                title: this.$t('Are_you_sure_to_save'),
                onOk: () => {
                    axios.post("/employeeInformation/updateEmployeeInformation", {serialnumber:this.serialnumber,...this.formItem}).then((res) => {
                        if (res) {
                            this.$Message.success(this.$t('Save_Successful'))
                            this.getData(this.serialnumber)
                        }
                    })
                }
            })
            
        },
        birthdayChange(val){
            this.formItem.brithday=this.date.dateVal(val,'YYYY-MM-DD')
        }
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.headerimg {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    flex-direction: column;

    img {
        width:100px;
        border:1px solid #cccccc;
        margin-bottom: 15px;
        min-height: 124px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/BasicInformation.vue